import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

import {
    BrowserRouter as Router,
    Switch,
    Route,
    Redirect
} from "react-router-dom";

import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Icon from '@material-ui/core/Icon';
import CheckIcon from '@material-ui/icons/Check';
import CircularProgress from '@material-ui/core/CircularProgress';
import Tooltip from '@material-ui/core/Tooltip';

import { makeStyles, ThemeProvider } from "@material-ui/core/styles";

import theme from '../theme';
import CoupleAppBar from './CoupleAppBar';
import CeremonyBuilder from './CeremonyBuilder/Builder';
import CeremonyInstructions from './CouplesArea/CeremonyInstructions';
import CoupleProfile from './CouplesArea/CoupleProfile';
import CoupleBalance from './CouplesArea/CoupleBalance';

import checkActiveSession from '../checkActiveSession';


const useStyles = makeStyles(theme => ({
    root: {
        flexGrow: 1,
        margin: theme.spacing(2),
        [theme.breakpoints.down('sm')]: {
            margin: 12,
            '&>div': {
                paddingLeft: 0,
                paddingRight: 0
            },
        },
    },
    paper: {
        padding: theme.spacing(3),
    },
    footerWrapper: {
        maxWidth: '920px',
        margin: 'auto'
    },
}));

const CeremonyWrapper = (props) => {
    const {
        couple,
        editing,
        setEditing
    } = props;

    useEffect(() => {
        document.title = 'Enduring Promises';
    });

    const [sentEmail, setSentEmail] = React.useState(false);
    const [sendingEmail, setSendingEmail] = React.useState(false);

    const handleSendButtonClick = () => {
        const data = {
            _token: window._token,
        };
        let url = '/couple/email-ceremony';
        setSendingEmail(true);
        fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        })
            .then(response => {
                return response.json();
            })
            .then(result => {
                setSentEmail(true);
                setSendingEmail(false);
                setTimeout(() => {
                    setSentEmail(false);
                }, 5000);
            })
            .catch(reason => {
                setSendingEmail(false);
                alert('An error prevented sending email. Please refresh the page and try again.');
            })
    }

    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <Typography align="center" variant="h5" color="textPrimary">
                    Welcome {couple.bride_first_name} & {couple.groom_first_name}
                </Typography>
            </Grid>
            {officiant &&
                <Grid item xs={12}>
                    <Box align="center" mt={2}>
                        <Tooltip title={editing ? "You have unsaved changes to the ceremony" : ""}>
                            <span>
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    endIcon={sendingEmail ? <CircularProgress size={20} /> : (sentEmail ? <CheckIcon /> : <Icon>send</Icon>)}
                                    disabled={(sendingEmail || editing) ? true : false}
                                    size="small"
                                    onClick={handleSendButtonClick}
                                >
                                    Send ceremony to {officiant.first_name}
                                </Button>
                            </span>
                        </Tooltip>
                    </Box>
                </Grid>
            }
            <Grid item xs={12}>
                <CeremonyBuilder id={couple.id} setOuterEditing={setEditing} />
            </Grid>
        </Grid>
    )
};

const CoupleArea = () => {
    const classes = useStyles();

    const [couple, setCouple] = React.useState(window.couple);
    const [officiant, setOfficiant] = React.useState(window.officiant);
    const [editing, setEditing] = React.useState(false);

    /* TODO: make sure all pages work even with no officiant assigned */
    /* TODO: change page title per page */

    const logout = () => {
        const form = document.getElementById('logout-form');
        form.submit();
        <Redirect to="/" />
    }

    if (!window.couple) {
        return (
            <ThemeProvider theme={theme}>
                <Box mt={3} align="center">
                    <Typography>No couple associated yet with this account!</Typography>
                </Box>
                <Box mt={3} align="center">
                    <Button color="primary" variant="contained" onClick={logout}>Log out</Button>
                </Box>
            </ThemeProvider>
        );
    }

    return (
        <ThemeProvider theme={theme}>
            <Router>
                <CoupleAppBar couple={couple} editing={editing} />
                <div className={classes.root}>
                    <Container maxWidth='xl'>
                        <Grid
                            container
                            direction="row"
                            justify="center"
                            alignItems="center"
                        >
                            <Grid item xs={12}>
                                <Switch>
                                    <Route exact path="/couple">
                                        <CeremonyWrapper couple={couple} editing={editing} setEditing={setEditing} />
                                    </Route>
                                    <Route path="/couple/instructions">
                                        <CeremonyInstructions couple={couple} officiant={officiant} />
                                    </Route>
                                    <Route path="/couple/profile">
                                        <CoupleProfile couple={couple} setCouple={setCouple} />
                                    </Route>
                                    <Route path="/couple/balance">
                                        <CoupleBalance id={couple.id} balance={couple.balance} officiant={officiant} />
                                    </Route>
                                </Switch>
                            </Grid>
                            {officiant &&
                                <Grid item xs={12} className={classes.footerWrapper}>
                                    <Box my={2}>
                                        <Divider />
                                    </Box>
                                    <div>
                                        <Typography align='center' color="textPrimary">
                                            Your officiant is {officiant.first_name} {officiant.last_name}
                                        </Typography>
                                        <Typography align='center'>
                                            <a href={`mailto:${officiant.email}`}>
                                                {officiant.email}
                                            </a>
                                        </Typography>
                                    </div>
                                </Grid>
                            }
                        </Grid>
                    </Container>
                </div>
            </Router>
        </ThemeProvider>
    );
}

if (document.getElementById('couples-root')) {
    ReactDOM.render(<CoupleArea />, document.getElementById('couples-root'));
    window._token = document.getElementsByName("csrf-token")[0].content;
    checkActiveSession();
}